var map = {
	"./recording_active.svg": "a9b1",
	"./recording_dark.svg": "a176",
	"./recording_dark_stop.svg": "261c",
	"./recording_disable.svg": "4695",
	"./recording_light.svg": "2956",
	"./recording_light_stop.svg": "f4a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65b6";